import store from '@/store';
import axios from 'axios';
import { BaseV1ApiService } from '@/services/backend/baseV1';

export class Fl44UnknownVolumeContractSupplementaryAgreements extends BaseV1ApiService {
    constructor() {
        super('purchases/fl44_unknown_volume');
    }

    async store(id, contractId, payload) {
        try {
            await axios.post(this.getUrl(`${id}/contracts/${contractId}/supplementary_agreements`), payload);
            await store.dispatch('showSuccessToast', 'Дополнительное соглашение успешно отправлено');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }

    async getXml(id, contractId, supplementaryAgreementId) {
        try {
            const response = await axios.get(this.getUrl(`${id}/contracts/${contractId}/supplementary_agreements/${supplementaryAgreementId}/xml`));
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getSupplementaryAgreementTerminationTemplateData(id, contractId) {
        try {
            const response = await axios.get(this.getUrl(`${id}/contracts/${contractId}/supplementary_agreements/termination_template`));
            return response.data.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async getTerminationSupplementaryAgreementXML(id, contractId, payload) {
        try {
            const response = await axios.post(this.getUrl(`${id}/contracts/${contractId}/supplementary_agreements/termination_xml`), payload);
            return response.data;
        } catch (err) {
            this.handleErrors(err);
        }
    }

    async storeCustomerSignedSupplementaryAgreementTermination(id, contractId, payload) {
        try {
            await axios.post(this.getUrl(`${id}/contracts/${contractId}/supplementary_agreements/store_termination`), payload);
            await store.dispatch('showSuccessToast', 'Дополнительное соглашение успешно подписано');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }

    async storeSigned(id, contractId, supplementaryAgreementId, path, payload) {
        try {
            await axios.put(this.getUrl(`${id}/contracts/${contractId}/supplementary_agreements/${supplementaryAgreementId}/${path}/store_signed`), {
                ...payload
            });
            await store.dispatch('showSuccessToast', 'Дополнительное соглашение успешно подписано');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }

    async signDecline(id, contractId, supplementaryAgreementId) {
        try {
            await axios.delete(this.getUrl(`${id}/contracts/${contractId}/supplementary_agreements/${supplementaryAgreementId}/customer/sign_decline`));
            await store.dispatch('showSuccessToast', 'Дополнительное соглашение успешно удалено');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }

    async storeSignedDisagreement(id, contractId, supplementaryAgreementId, path, payload, disagreementId = null) {
        try {
            await axios.post(this.getUrl(`${id}/contracts/${contractId}/supplementary_agreements/${supplementaryAgreementId}/${path}/${disagreementId ? disagreementId : 'disagreement'}`), payload);
            await store.dispatch('showSuccessToast', 'Действие выполнено успешно');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }

    async updateSupplementaryAgreementLimits(id, contractId, supplementaryAgreementId, payload) {
        try {
            await axios.post(this.getUrl(`${id}/contracts/${contractId}/supplementary_agreements/${supplementaryAgreementId}/update_limits`), payload);
            await store.dispatch('showSuccessToast', 'Лимиты обновлены');
            return true;
        } catch (err) {
            this.handleErrors(err);
            return false;
        }
    }
}
